import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect, useState,} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import WorkspaceContext from "../../WorkspaceContext";
import _ from "lodash"
import Shops from "./Shops";
import ShopDetail from "./ShopDetail";
import ProductDetail from "./ProductDetail";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {product_getById_Api, shop_getById_Api} from "../../../../apis";

export const ShopContainerContext = React.createContext(
    {}
)

const ShopContainerProvider = ({children}) => {
    const currentShopId = useRouteSearchParam("current_shop_id")
    const currentProductId = useRouteSearchParam("current_product_id")
    const [current_shop_id, setCurrentShopId] = useState(currentShopId)
    const [current_product_id, setCurrentProductId] = useState(currentProductId);

    const {onChangeSearchParams} = useRouterSearchParam({})

    const onSelectShopContainerRoute = (values) => {
        if (_.has(values, 'current_shop_id')) setCurrentShopId(values?.current_shop_id)
        if (_.has(values, 'current_product_id')) setCurrentProductId(values?.current_product_id)

        onChangeSearchParams(values, 'replace')
    }

    return (
        <ShopContainerContext.Provider
            value={{
                current_shop_id, setCurrentShopId,
                current_product_id, setCurrentProductId,
                ...{onSelectShopContainerRoute}
            }}>
            {children}
        </ShopContainerContext.Provider>
    )
}


const ShopContainer = ({}) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);
    const currentShopId = useRouteSearchParam("current_shop_id")
    const currentProductId = useRouteSearchParam("current_product_id")
    const {
        current_shop_id, setCurrentShopId,
        current_product_id, setCurrentProductId,
    } = useContext(ShopContainerContext)
    const [selectedShop, setSelectedShop] = useState();
    const [selectedProduct, setSelectedProduct] = useState();


    const {handleAsyncAction: getShopById} = useAsyncAction({
        apiInfo: shop_getById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data', []);
            setSelectedShop(dataItem);
        },
    })
    const {handleAsyncAction: getProductById} = useAsyncAction({
        apiInfo: product_getById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data', []);
            setSelectedProduct(dataItem);
        },
    })
    useEffect(() => {
        setCurrentShopId(currentShopId)
        if (currentShopId) {
            getShopById({}, {id: currentShopId})
        } else {
            setSelectedShop(null);
        }
    }, [currentShopId])
    useEffect(() => {
        setCurrentProductId(currentProductId)
        if (currentProductId) {
            getProductById({}, {id: currentProductId})
        } else {
            setSelectedProduct(null);
        }
    }, [currentProductId])


    if (!!current_shop_id && !!current_product_id) {
        if (!(selectedShop && selectedProduct)) return null;

        return (
            <ProductDetail shop={selectedShop} product={selectedProduct}/>
        )
    } else if (!!current_shop_id && !!!current_product_id) {
        if (!(selectedShop)) return null;

        return (
            <ShopDetail shop={selectedShop}/>
        )
    }

    return (
        <Shops organization={{organization}} owner_id={organization?.id} owner_type={organization?._type}/>
    )
}


export default nest(ShopContainerProvider, ShopContainer)
